/**
 * JALA custom JavaScript (loaded from layout/theme.liquid).
 * Symmetry's developer notes on theme events live in the theme docs:
 * on:cart:add, on:cart:after-merge, dispatch:cart-drawer:refresh, etc.
 */

/* ============================================
   JALA - Cart drawer "You may like" quick add
   Compact recommendation cards with a "+ Add" button.
   One size products add straight away; products with sizes
   show size buttons inside the card first.
   ============================================ */
(function () {
  if (window.jalaQuickAddLoaded) return;
  window.jalaQuickAddLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var css = [
    'cart-drawer .cart-item-upsells .collection-slider{padding-top:16px!important;padding-bottom:16px!important}',
    'cart-drawer .cart-item-upsells .product-info-label{font-size:15px}',
    'cart-drawer .cart-item-upsells .slider__grid{grid-auto-columns:78%!important;grid-template-columns:none!important;gap:10px!important}',
    'cart-drawer .cart-item-upsells .product-block .block-inner-inner{display:flex!important;flex-wrap:wrap;align-items:center;gap:14px;background:#fff;padding:10px;border-radius:4px}',
    'cart-drawer .cart-item-upsells .product-block .image-cont{flex:0 0 72px;width:72px;margin:0!important}',
    'cart-drawer .cart-item-upsells .product-label-container,cart-drawer .cart-item-upsells .image-page-button,cart-drawer .cart-item-upsells .product-block__image--secondary,cart-drawer .cart-item-upsells .yotpo,cart-drawer .cart-item-upsells [class*="yotpo"],cart-drawer .cart-item-upsells .col-title-reviews > a:not(.product-link){display:none!important}',
    'cart-drawer .cart-item-upsells .col-title-reviews{display:block!important}',
    'cart-drawer .cart-item-upsells .product-block__detail{flex:1;padding:0!important;margin:0!important;text-align:left}',
    'cart-drawer .cart-item-upsells .product-block__title{font-size:14px;line-height:1.3;margin:0 0 4px}',
    'cart-drawer .cart-item-upsells .product-price{font-size:14px;margin:0}',
    'cart-drawer .jala-cart-policies{display:none!important}',
    'cart-drawer .jala-qa-btn{margin-left:auto;align-self:center;background:none;border:0;padding:6px 4px;font:inherit;font-size:14px;color:#1a1a1a;cursor:pointer;white-space:nowrap;display:flex;align-items:center;gap:6px}',
    'cart-drawer .jala-qa-btn span{font-size:20px;line-height:1;font-weight:300}',
    'cart-drawer .jala-qa-btn:disabled{opacity:.5;cursor:default}',
    'cart-drawer .jala-qa-sizes{display:flex;flex-wrap:wrap;gap:4px;margin-top:8px}',
    'cart-drawer .jala-qa-sizes[hidden]{display:none}',
    'cart-drawer .jala-qa-size{min-width:30px;padding:5px 6px;border:1px solid #cfcfcf;background:#fff;font:inherit;font-size:11px;cursor:pointer;border-radius:3px;color:#1a1a1a}',
    'cart-drawer .jala-qa-size:hover{border-color:#1a1a1a}',
    'cart-drawer .jala-qa-size:disabled{opacity:.35;text-decoration:line-through;cursor:default}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('jala-quick-add-css')) return;
    var s = document.createElement('style');
    s.id = 'jala-quick-add-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  function addVariant(id, btn) {
    btn.disabled = true;
    var old = btn.textContent;
    btn.textContent = 'Adding';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { btn.textContent = 'Added'; refreshDrawer(); })
      .catch(function () {
        btn.textContent = 'Sold out';
        setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1800);
      });
  }

  // Label each choice by the option that actually varies (usually Size), skipping Color.
  function labelFor(p, v) {
    if (p.options && p.options.length > 1) {
      for (var i = 0; i < p.options.length; i++) {
        var name = p.options[i].name || p.options[i];
        var vals = {};
        p.variants.forEach(function (x) { vals[x.options[i]] = 1; });
        if (Object.keys(vals).length > 1 && !/colou?r/i.test(name)) return v.options[i];
      }
    }
    return v.title;
  }

  function onAdd(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var card = btn.closest('product-block');
    var link = card && card.querySelector('a.product-link');
    if (!link) return;

    var sizes = card.querySelector('.jala-qa-sizes');
    if (sizes) { sizes.hidden = !sizes.hidden; return; }

    var handle = link.pathname.split('/products/')[1];
    btn.disabled = true;
    fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        btn.disabled = false;
        if (p.variants.length === 1) { addVariant(p.variants[0].id, btn); return; }
        var wrap = document.createElement('div');
        wrap.className = 'jala-qa-sizes';
        p.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jala-qa-size';
          b.textContent = labelFor(p, v);
          b.disabled = !v.available;
          b.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            addVariant(v.id, b);
          });
          wrap.appendChild(b);
        });
        card.querySelector('.product-block__detail').appendChild(wrap);
      })
      .catch(function () { btn.disabled = false; window.location = link.href; });
  }

  function decorate() {
    document.querySelectorAll('cart-drawer .cart-item-upsells product-block').forEach(function (card) {
      if (card.querySelector('.jala-qa-btn')) return;
      var host = card.querySelector('.block-inner-inner');
      if (!host) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jala-qa-btn';
      b.setAttribute('aria-label', 'Add to cart');
      b.innerHTML = '<span aria-hidden="true">+</span> Add';
      b.addEventListener('click', onAdd);
      host.appendChild(b);
    });
  }

  function start() {
    injectCss();
    decorate();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(decorate).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================
   JALA - Cart drawer discount code + order summary
   Lives in the scrolling part of the drawer, after the
   recommendations. The pinned footer keeps only Checkout+
   and the checkout buttons.
   ============================================ */
(function () {
  if (window.jalaCartSummaryLoaded) return;
  window.jalaCartSummaryLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FREE_SHIPPING_CENTS = 10000; // $100 domestic free shipping

  var css = [
    '.jala-sum{padding-top:24px;padding-bottom:8px;border-top:1px solid #ece9e4}',
    '.jala-sum__h{font-size:15px;font-weight:600;margin:0 0 12px;letter-spacing:.01em}',
    '.jala-sum__form{display:flex;gap:8px;margin:0}',
    '.jala-sum__input{flex:1;min-width:0;height:44px;padding:0 12px;border:1px solid #d6d3ce;border-radius:3px;font:inherit;font-size:14px;background:#fff;color:#1a1a1a}',
    '.jala-sum__input:focus{outline:none;border-color:#1a1a1a}',
    '.jala-sum__apply{height:44px;padding:0 22px;border:0;border-radius:3px;background:#1a1a1a;color:#fff;font:inherit;font-size:14px;cursor:pointer}',
    '.jala-sum__apply:disabled{opacity:.6;cursor:default}',
    '.jala-sum__msg{font-size:12px;margin:8px 0 0;color:#a3324a}',
    '.jala-sum__msg:empty{display:none}',
    '.jala-sum__chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}',
    '.jala-sum__chips:empty{display:none}',
    '.jala-sum__chip{display:inline-flex;align-items:center;gap:8px;padding:6px 10px;background:#efece7;border-radius:3px;font-size:12px;letter-spacing:.03em}',
    '.jala-sum__chip button{background:none;border:0;padding:0;font-size:15px;line-height:1;cursor:pointer;color:#555}',
    '.jala-sum__block + .jala-sum__block{margin-top:28px}',
    '.jala-sum__row{display:flex;justify-content:space-between;font-size:14px;color:#6b6762;margin:0 0 8px}',
    '.jala-sum__row--total{color:#1a1a1a;font-weight:600;font-size:15px;margin-top:12px;padding-top:12px;border-top:1px solid #ece9e4}',
    '.jala-sum__row--save span:last-child{color:#3A4831}',
    '.jala-sum__rewards{margin-top:20px}',
    '.jala-sum__rewards:empty{display:none}',
    /* keep the rewards banner hidden until it has moved, so it doesn't jump */
    'cart-drawer .cart-drawer__footer .BLOY-cart__rewards{display:none!important}',
    /* hide the Shopify Inbox chat bubble while the cart is open */
    'body:has(cart-drawer[aria-hidden="false"]) shopify-chat{display:none!important}',
    /* footer: hide the old subtotal + policy line, keep Checkout+ and buttons */
    'cart-drawer .cart-drawer__footer > div:has(> .subtotal){display:none!important}',
    'cart-drawer .cart-drawer__footer{padding-top:14px!important}'
  ].join('\n');

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function injectCss() {
    if (document.getElementById('jala-cart-summary-css')) return;
    var s = document.createElement('style');
    s.id = 'jala-cart-summary-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  function setCodes(codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }

  function currentCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'jala-sum cart-drawer__content-item';
    el.innerHTML =
      '<div class="jala-sum__block">' +
        '<p class="jala-sum__h">Discount code</p>' +
        '<form class="jala-sum__form" novalidate>' +
          '<input class="jala-sum__input" type="text" name="code" placeholder="Enter code" autocomplete="off" autocapitalize="characters" aria-label="Discount code">' +
          '<button class="jala-sum__apply" type="submit">Apply</button>' +
        '</form>' +
        '<p class="jala-sum__msg" role="status"></p>' +
        '<div class="jala-sum__chips"></div>' +
      '</div>' +
      '<div class="jala-sum__block">' +
        '<p class="jala-sum__h">Order summary</p>' +
        '<div class="jala-sum__rows"></div>' +
      '</div>' +
      '<div class="jala-sum__rewards"></div>';

    el.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = el.querySelector('.jala-sum__input');
      var btn = el.querySelector('.jala-sum__apply');
      var msg = el.querySelector('.jala-sum__msg');
      var code = input.value.trim();
      if (!code) return;
      btn.disabled = true; msg.textContent = '';
      getCart()
        .then(function (cart) {
          var codes = currentCodes(cart);
          if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) codes.push(code);
          return setCodes(codes);
        })
        .then(function (cart) {
          var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
          if (!hit || !hit.applicable) {
            msg.textContent = "Hmm, that code doesn't work for this cart.";
            return setCodes(currentCodes(cart));
          }
          input.value = '';
        })
        .catch(function () { msg.textContent = "Hmm, that code doesn't work for this cart."; })
        .then(function () { btn.disabled = false; refreshDrawer(); update(); });
    });
    return el;
  }

  function render(el, cart) {
    var chips = el.querySelector('.jala-sum__chips');
    chips.innerHTML = '';
    currentCodes(cart).forEach(function (code) {
      var c = document.createElement('span');
      c.className = 'jala-sum__chip';
      c.innerHTML = '<span></span><button type="button" aria-label="Remove code">&times;</button>';
      c.firstChild.textContent = code;
      c.querySelector('button').addEventListener('click', function () {
        setCodes(currentCodes(cart).filter(function (x) { return x !== code; }))
          .then(function () { refreshDrawer(); update(); });
      });
      chips.appendChild(c);
    });

    var cur = cart.currency;
    // Subtotal at full price, then one Savings line covering sale prices, automatic discounts and codes.
    var fullPrice = Math.max(cart.original_total_price || 0, cart.items_subtotal_price);
    var savings = Math.max(0, fullPrice - cart.total_price);
    var rows = '<p class="jala-sum__row"><span>Subtotal</span><span>' + money(fullPrice, cur) + '</span></p>';
    if (savings > 0) rows += '<p class="jala-sum__row jala-sum__row--save"><span>Savings</span><span>&minus;' + money(savings, cur) + '</span></p>';
    rows += '<p class="jala-sum__row"><span>Shipping</span><span>' + (cart.total_price >= FREE_SHIPPING_CENTS ? 'Free' : 'Calculated at checkout') + '</span></p>';
    rows += '<p class="jala-sum__row jala-sum__row--total"><span>Total</span><span>' + money(cart.total_price, cur) + '</span></p>';
    el.querySelector('.jala-sum__rows').innerHTML = rows;
  }

  var busy = false, again = false;
  function update() {
    if (busy) { again = true; return; }
    var content = document.querySelector('cart-drawer .cart-drawer__content');
    if (!content) return;
    var el = content.querySelector('.jala-sum');
    if (!el) { el = build(); }
    if (el.parentNode !== content || content.lastElementChild !== el) content.appendChild(el);
    // Move the rewards (BLOY) banner out of the pinned footer to the end of the summary.
    var bloy = document.querySelector('cart-drawer .cart-drawer__footer .BLOY-cart__rewards');
    if (bloy) {
      var slot = el.querySelector('.jala-sum__rewards');
      slot.innerHTML = '';
      slot.appendChild(bloy);
    }
    busy = true;
    getCart()
      .then(function (cart) { render(el, cart); el.hidden = !cart.item_count; })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; update(); } });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(update, 250); }

  function start() {
    injectCss();
    update();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!(t.closest && t.closest('.jala-sum'))) { schedule(); return; }
      }
    }).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('on:cart:after-merge', schedule);
    document.addEventListener('on:cart:add', schedule);
    drawer.addEventListener('on:cart-drawer:before-open', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
